// useUnreadTexts.js - The count on the Inbox badge in the nav.
//
// It lives beside the layout rather than in lib/hooks.js because it is one
// screen's concern, and it asks for a single count rather than a page of
// messages: the nav does not need the messages, only the number.
//
// It updates the same way everything else does, through lib/live.js: instantly
// when the stream is up, on a slow timer when it is not. `enabled` is false for
// anybody without permission to read messages, and then nothing is requested at
// all rather than requesting and hiding the answer.

import { useCallback, useEffect, useState } from "react";

import { adminApi } from "../lib/api.js";
import { useLiveOrPoll } from "../lib/live.js";

export function useUnreadTexts(enabled = true) {
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      const result = await adminApi.messages({ limit: 1, unread: "true" });
      setCount(Number(result?.unread) || 0);
    } catch {
      // A failed count is not worth a message on screen. The number simply does
      // not move until the next attempt.
    }
  }, [enabled]);

  useEffect(() => { refresh(); }, [refresh]);
  useLiveOrPoll(enabled ? ["message.inbound", "message.status"] : [], refresh, { interval: 20_000 });

  return enabled ? count : 0;
}
